import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo-how-far-will-fudge-go_00.jpg";

const data: ReplicaItemType = {
  id: "the-quibbler-v1-how-far-will-fudge-go-grade-b",
  name: "The Quibbler v1 - How Far Will Fudge Go Gain Gringotts (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Quibbler v1",
    tertiary: "How Far Will Fudge Go To Gain Gringotts",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
